import React from 'react';
import { PageWrapper } from '../../components/common';
import ListadoPesajes from '../../components/balanza/Listar_Pesaje';

const Listar_Pesaje: React.FC = () => {
  return (
    <PageWrapper>
      <ListadoPesajes />
    </PageWrapper>
  );
};

export default Listar_Pesaje;